<template>
    <div class="user-bar">
        <button
            @click="$emit('loginClick')"
            class="btn btn--md btn--w-144 btn__primary--yellow"
        >
            {{ $t('login') | capitalize }}
        </button>
        <router-link
            :to="{ name: routeNames.register }"
            tag="button"
            class="btn btn__secondary btn__outline--white btn--w-144 btn--md"
        >
            {{ $t('register') | capitalize }}
        </router-link>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';

    export default {
        name: 'GuestBar',
        data() {
            return {
                routeNames,
            };
        }
    };
</script>

<style scoped>
.btn__primary--yellow { margin-right: 8px; }
</style>



// WEBPACK FOOTER //
// src/app/modules/authentication/components/GuestBar.vue